import { getPublicEnv } from '@tucan/utils'
import Joi from 'joi'

export interface SettingDesignType {
  primaryColor?: string
  secondaryColor?: string
  backgroundColor?: string
  dark?: boolean
  compact?: boolean
  manualConfig?: string

  overrides: {
    type: string
    primaryColor?: string
    secondaryColor?: string
    backgroundColor?: string
    dark?: boolean
    compact?: boolean
    manualConfig?: string
  }[]
}

const fromJson = (v) => {
  if (!v) {
    return
  }

  try {
    return JSON.parse(v)
  } catch (e) {
    // process.exit(1)
  }
}

export const getDefaultDesign = (): SettingDesignType => {
  const result = Joi.object()
    .keys({
      backgroundColor: Joi.string(),
      compact: Joi.boolean(),
      dark: Joi.boolean(),

      overrides: Joi.array()
        .items(
          Joi.object().keys({
            backgroundColor: Joi.string(),
            compact: Joi.boolean(),
            dark: Joi.boolean(),
            primaryColor: Joi.string(),
            secondaryColor: Joi.string(),
            type: Joi.string().required(),
          })
        )
        .default([]),

      primaryColor: Joi.string(),
      secondaryColor: Joi.string(),
    })
    .default({})
    .validate(fromJson(getPublicEnv('DEFAULT_DESIGN')))

  return result.value
}
